import { render, staticRenderFns } from "./NewBuy.vue?vue&type=template&id=f8bb4eae&scoped=true"
import script from "./NewBuy.vue?vue&type=script&lang=js"
export * from "./NewBuy.vue?vue&type=script&lang=js"
import style0 from "./NewBuy.vue?vue&type=style&index=0&id=f8bb4eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb4eae",
  null
  
)

export default component.exports